import axios from "axios";
import { ISpecificExportsQuery } from "../models/specificExportsQuery";

export const downloadSpecificExport = async (query: ISpecificExportsQuery) => {
    const res = await axios.post(`/api/specificExports`, query, { responseType: "blob" });
    const url = window.URL.createObjectURL(
        new Blob([res.data], { type: res.headers["content-type"] })
    );

    let fileName = res.headers["content-type"] && res.headers["content-type"].includes("zip") ? "export.zip" : "export.csv";

    try {
        fileName = res.headers['content-disposition'].split('filename=')[1].split(';')[0];
    } catch {
        console.warn("Cant read download filename from headers, using default name")
    }

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode!.removeChild(link);
};
